<style lang="less" scoped>
el-menu{position: fixed;top:60px;bottom: 0;left: 0;width: 220px;overflow-y: auto;background-color: #2b4063!important;
  &::-webkit-scrollbar {display: none;}
}
.view{overflow-y: auto;
  &::-webkit-scrollbar {display: none;}
}
.ht{position:relative;}
.banner{position: fixed;top:0px;left: 0;right:0px;padding:10px;height: 60px;background: url('../../../../../static/images/szdp/title.png') no-repeat; background-size: 100% 100%;;text-align:left;color:white;z-index:10099;}
img{display: inline-block;margin:5px;letter-spacing: 2px;height: 30px;}
span{float:right;letter-spacing: 1px;font-size: 18px;margin-top: 10px;}
.out:hover{color:#26f5f5;}
.box {height: 100%;}
</style>

<template>
  <div class="banner">
  </div>
</template>
<script>
export default {
  data()
  {
    return {
      admin: '',
      weather: null,
      lower: null,
      higher: null
    }
  },
  created()
  {
    if (localStorage.getItem('username'))
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 28,
        _exp: `username = '${localStorage.getItem('username')}'`
      }
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length === 1)
          this.admin = `${ret[0].passport}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/DigitalScreen/Top.vue